import { Component, OnInit, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-formarray-item',
  templateUrl: './formarray-item.component.html',
  styleUrls: ['./formarray-item.component.css']
})
export class FormarrayItemComponent implements OnInit {

  @Input() itemTemplate: TemplateRef<any>;
  @Input() itemContext: any;

  constructor() { }

  ngOnInit() {
  }

}
